module.exports = __webpack_public_path__ + "img/noah_logo.545fd9bc.svg";